import { Box, styled, Typography } from '@mui/material';

export const AlertContainer = styled(Box)`
  position: absolute;
  bottom: 0;
  right: 0;
`;

export const SubHeaderText = styled(Typography)(
  ({ theme }) => `
    font-size: 16px;
    font-weight: 300;
    color: '${theme.palette.brand.black}';
    margin-top: 10px;
  `,
);

export const SubHeader = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
`;

export const Container = styled(Box)`
  padding-top: 20px;
`;
export const BoxContainer = styled(Box)`
  position: relative;
  height: 95%;
`;
